import { render, staticRenderFns } from "./MiscStats.vue?vue&type=template&id=2b93d4b6&scoped=true"
import script from "./MiscStats.vue?vue&type=script&lang=js"
export * from "./MiscStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b93d4b6",
  null
  
)

export default component.exports